/* eslint-disable react-hooks/exhaustive-deps */
import { Flex, Text, useColorMode, useColorStyle } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import emptyTableGraphics from '../../../../assets/image/icon-emptyTableGraphics.svg';

import { PolicyType, PolicyType2Service } from '../../../../types/app';
import RedirectLink from '@Components/RedirectLink';
import { usePermissionStore } from '../../../../models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';

export const GrantedAccess = React.memo(
  (props: { selectedPolicyType: string; orgId: string }) => {
    const { widthEditablePermission } = usePermissionStore();
    const adminEditPermission = widthEditablePermission(
      PermissionNameEnum.administrator
    );
    const [colorMode] = useColorMode();
    const [colorStyle] = useColorStyle({ colorMode });
    const { t } = useTranslation();
    // const _params = JSON.parse(JSON.stringify(PolicyType2Service));
    const _params = PolicyType2Service;
    const serviceName = t(
      `common.service.${
        _params[Number(props.selectedPolicyType) as PolicyType]
      }`
    );
    const url =
      'type=provision&orgId=' +
      props.orgId +
      '&service=' +
      _params[Number(props.selectedPolicyType) as PolicyType];

    return (
      <Flex
        mt="10vh"
        alignItems="center"
        justifyContent="center"
        direction="column"
      >
        <img src={emptyTableGraphics} />

        <Flex m="10px 0px">
          <Text fontSize="lg" lineHeight="lg" color={colorStyle.color.primary}>
            {t(`globalSetting.grantedAccess.service.title`, {
              service: serviceName,
            })}
          </Text>
        </Flex>
        <Flex m="10px 0px">
          <Text
            fontSize="lg"
            lineHeight="lg"
            color={colorStyle.color.secondary}
          >
            {t(`globalSetting.grantedAccess.service.description`, {
              service: serviceName,
            })}
          </Text>
        </Flex>
        <Flex m="10px 0px">
          <RedirectLink
            href={`dashboard?${url}`}
            disabled={!adminEditPermission}
          >
            {t(`globalSetting.grantedAccess.service.link`, {
              service: serviceName,
            })}
          </RedirectLink>
        </Flex>
      </Flex>
    );
  }
);
